import { ComboData } from '../combo.data.model';

export class ItemAcountRecherche {
  DateDebut: string;
  DateFin: string;
  referenceItem: string;
  trieItemAsc: boolean = true;
  trieItemAccount: ComboData = { 'text': '', 'id': '' };
  trieItemAccountListe: ComboData[] = [];
}
